var tag = {};

(function (tagApp) {
	var filterModel = {
		Tag: $('#tagItem').val(),
		ArticlePage: 1,
		EventPage: 1,
		PageSize: 8,
		IsCampaign: $('#isCampaign').val(),
		Tags: ''
	};

	var fromPopState = false;
	var blockPopstateEvent = true;
	var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

	if (browserSupportsHistoryApi) {
		// prevent Chrome from calling onpopstate on initial load
		$(window).on('load', function () {
			// The timeout ensures that popstate-events will be unblocked right
			// after the load event occured, but not in the same event-loop cycle.
			setTimeout(function () { blockPopstateEvent = false; }, 0);
		});

		$(window).on('popstate', function () {
			if (blockPopstateEvent && document.readyState === "complete") {
				return;
			}
			fromPopState = true;
			performSearchFromUrl();
		});
	}

	function pushHistory() {
		if (browserSupportsHistoryApi && !fromPopState) {
			var currentPath = window.location.pathname;
			var query = "?";
			var queryArray = [];
			if (filterModel.ArticlePage) {
				queryArray.push("articlepage=" + filterModel.ArticlePage);
			}
			if (filterModel.EventPage) {
				queryArray.push("eventpage=" + filterModel.EventPage);
			}
			if (filterModel.Tags) {
				queryArray.push("tags=" + filterModel.Tags);
			}
			query += queryArray.join("&");
			history.pushState(null, null, currentPath + query);
		}
		fromPopState = false;
	}

	function performSearchFromUrl() {
		filterModel.ArticlePage = 1;
		filterModel.EventPage = 1;

		if (window.location.search.length > 1) {
			for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
				nKeyId < aCouples.length;
				nKeyId++) {
				aItKey = aCouples[nKeyId].split("=");
				if (aItKey.length <= 1)
					continue;
				var key = decodeURIComponent(aItKey[0]).toLowerCase();
				var val = decodeURIComponent(aItKey[1]);

				if (key === "articlepage") {
					filterModel.ArticlePage = val;
				} else if (key === "eventpage") {
					filterModel.EventPage = val;
				} else if (key === "tags") {
					filterModel.Tags = val;
				}
			}
		}
		tagApp.GetArticleResults(false);
		tagApp.GetEventResults();
	}

	tagApp.GetArticleResults = function (callPushHistory = true) {
		$.ajax({
			url: "/umbraco/surface/TagSurface/GetArticlesByTag",
			type: "POST",
			dataType: "html",
			data: filterModel,
			success: function (data) {
				$(".articles").html(data);
				$('.articles .section-header.color-theme-campaign').css('color', $('#titleColor').val());
				if (callPushHistory) pushHistory();
			}
		});
	};

	tagApp.GetEventResults = function () {
		$.ajax({
			url: "/umbraco/surface/TagSurface/GetEventsByTag",
			type: "POST",
			dataType: "html",
			data: filterModel,
			success: function (data) {
				$(".events").html(data);
				$('.events .section-header.color-theme-campaign').css('color', $('#titleColor').val());
				pushHistory();
			}
		});
	};

	$(document).ready(function () {
		//Get url params on load
		const urlParams = new URLSearchParams(window.location.search);

		//check if querystring params exist on load/reload
		if (urlParams.get('articlepage'))
			filterModel.ArticlePage = urlParams.get('articlepage');

		if (urlParams.get('eventpage'))
			filterModel.EventPage = urlParams.get('eventpage');

		if (urlParams.get('tags'))
			filterModel.Tags = urlParams.get('tags');

		//on filter tool click event submit
		$(document).on('click', '.landing-page-filter__button.js-submit', function (e) {
			e.preventDefault();
			filterModel.Tags = $('.landing-page-filter__select').map(function () { if ($(this).val().length) { return $(this).val() } }).get().join();
			filterModel.ArticlePage = 1;
			filterModel.EventPage = 1;
			tagApp.GetArticleResults();
			tagApp.GetEventResults();
		});

		//on filter tool click event clear filters
		$(document).on('click', '.landing-page-filter__button.js-clear', function (e) {
			e.preventDefault();
			$('.landing-page-filter__select').val($('.landing-page-filter__select option:first').val());
			filterModel.Tags = "";
			filterModel.ArticlePage = 1;
			filterModel.EventPage = 1;
			tagApp.GetArticleResults();
			tagApp.GetEventResults();
		});

		//on pagination click event
		$(document).on('click', 'ul.pagination a', function (e) {
			e.preventDefault();
			var type = $(this).closest('ul').data('type');
			if (type === "BlogArticle") {
				filterModel.ArticlePage = $(this).data('page');
				tagApp.GetArticleResults();
				paginationScrollToTop(".articles");
			}
			else if (type === "Event") {
				filterModel.EventPage = $(this).data('page');
				tagApp.GetEventResults();
				paginationScrollToTop(".events");
			}
		});

		function paginationScrollToTop(classToScrollTo) {
			$([document.documentElement, document.body]).animate({
				scrollTop: $(classToScrollTo).offset().top - $("header").outerHeight()
			}, 200);
		}
	});

})(tag);
